/* eslint-disable import/prefer-default-export */
import Moment from 'moment';
import { padronesEnum } from 'views/Tramites/GPM/enums';

export const PADRONES_HABILITADOS = [
  'PREDIO',
  /* 'INFRACCIONES',
  'COMERCIO_INFORMAL',
  'EXPEDIENTE_DE_ANUNCIO',
  'ESTACIONAMIENTO',
  'LOTES_DE_PANTEON',
  'MERCADO', */
];

export const makeOpc = (id, descripcion) => ({ id, descripcion });

export const ACCIONES_TRAMITES = [
  makeOpc('CREAR_TRAMITE', 'Iniciar trámite'),
  makeOpc('EDITAR_TRAMITE', 'Editar trámite'),
  makeOpc('FINALIZAR_TRAMITE', 'Finalizar trámite'),
  makeOpc('CANCELAR_TRAMITE', 'Cancelar trámite'),
];

export const GLOBAL_ACCIONES = [
  makeOpc('LOGIN', 'Inicio de sesión'),
  makeOpc('ORDEN_DE_PAGO_CAJA', 'Orden de pago en caja'),
  makeOpc('GENERAR_RECIBO_CAJA', 'Generar estado de cuenta'),
  makeOpc('CONSULTAR_RECIBO_CAJA', 'Consulta estado de cuenta'),
  makeOpc('GENERAR_FACTURA', 'Factura'),
  makeOpc('CONVENIO', 'Iniciar convenio'),
  makeOpc('CARGOS_CONVENIOS', 'cargos convenios'),
  makeOpc('CREAR_CONVENIO', 'Convenio creado'),
  makeOpc('CANCELAR_CONVENIO', 'Convenios cancelados'),
  makeOpc('CREAR_PARTICIPE', 'Crear partícipe'),
  makeOpc('CREAR_CARGOS', 'Cargos aplicados'),
  makeOpc('MODIFICACION_CARGO', 'Modificación cargos'),
  makeOpc('CANCELAR_CARGO', 'Cargos cancelados'),
  makeOpc('CARGO_EXENTO', 'Cargo exento'),
  makeOpc('APLICAR_DESCUENTO', 'Descuentos aplicados'),
  makeOpc('CREAR_ALERTAS_EN_TRAMITE', 'Alertas aplicadas en trámite'),
  makeOpc('CREAR_ALERTAS', 'Alertas aplicadas'),
  makeOpc('EDITAR_ALERTAS', 'Alerta Cancelada'),
  makeOpc('EDITAR_ALERTAS_EN_TRAMITE', 'Alerta Cancelada en trámite'),
  makeOpc('CARGO_PRESCRIPTO', 'Cargo prescripto'),
];

export const ACCIONES_POR_PADRON = {
  [padronesEnum.PREDIO]: [
    makeOpc('CREAR_PREDIO', 'Crear predio'),
    makeOpc('EDITAR_PREDIO', 'Editar predio'),
    makeOpc('EDITAR_PREDIO_TRAMITE', 'Editar predio tramite'),
    makeOpc('EDITAR_DIRECCION_PREDIO', 'Editar dirección'),
  ],
  [padronesEnum.INFRACCIONES]: [
    makeOpc('CREAR_INFRACCION', 'Crear infracción'),
    makeOpc('ACTUALIZAR_INFRACCION', 'Actualizar infracción'),
    makeOpc('ACTUALIZAR_ESTADO_INFRACCION', 'Actualizar estado de infracción'),
    makeOpc('CREAR_CONCEPTOS_DE_INFRACCION', 'Crear conceptos de infracción'),
  ],
  [padronesEnum.COMERCIO_INFORMAL]: [
    makeOpc('CREAR_EMPRESA', 'Crear comercio'),
    makeOpc('EDITAR_EMPRESA_GENERAL', 'Editar comercio'),
  ],
  [padronesEnum.EXPEDIENTE_DE_ANUNCIO]: [
    makeOpc('CREAR_ANUNCIO', 'Crear anuncio'),
    makeOpc('EDITAR_ANUNCIO', 'Editar anuncio'),
  ],
  [padronesEnum.ESTACIONAMIENTO]: [
    makeOpc('CREAR_ESTACIONAMIENTO', 'Crear estacionamiento'),
    makeOpc('EDITAR_ESTACIONAMIENTO', 'Editar estacionamiento'),
  ],
  [padronesEnum.LOTES_DE_PANTEON]: [
    makeOpc('CREAR_PANTEONES', 'Crear panteones'),
    makeOpc('EDITAR_PANTEONES', 'Editar panteones'),
    makeOpc('ASIGNAR_DIFUNTOS', 'Asignar difunto'),
    makeOpc('EDITAR_DIFUNTOS', 'Editar difunto'),
  ],
  [padronesEnum.MERCADO]: [
    makeOpc('CREAR_EXPEDIENDTE_MERCADOS', 'Crear mercado'),
    makeOpc('EDITAR_EXPEDIENTE_MERCADOS', 'Editar mercado'),
  ],
};

export const normalizeSearchParams = (rawParams) => {
  const {
    fecha_inicio, fecha_fin, id_padron, ...rest
  } = rawParams;
  const filteredRest = id_padron === 'TRAMITES' ? rest : { ...rest, id_padron };
  return {
    ...filteredRest,
    fecha_inicio: fecha_inicio
      ? fecha_inicio.startOf('day').format('YYYY-MM-DD HH:mm:ss')
      : undefined,
    fecha_fin: fecha_fin
      ? fecha_fin.endOf('day').format('YYYY-MM-DD HH:mm:ss')
      : undefined,
  };
};

export const getPadronOptions = () => {
  const padronesFromEnum = Object.entries(padronesEnum)
    .filter(([clave]) => PADRONES_HABILITADOS.includes(clave))
    .map(([clave, id]) => ({
      id,
      descripcion: clave
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (l) => l.toUpperCase()),
    }));

  return [
    ...padronesFromEnum,
    {
      id: 'TRAMITES',
      descripcion: 'Trámites',
    },
  ];
};

export const getAccionesByPadron = (padronId) => {
  if (!padronId) {
    return GLOBAL_ACCIONES.sort((a, b) => a.descripcion.localeCompare(b.descripcion));
  }

  if (padronId === 'TRAMITES') {
    return ACCIONES_TRAMITES.sort((a, b) => a.descripcion.localeCompare(b.descripcion));
  }

  const especificas = ACCIONES_POR_PADRON[padronId] || [];
  return especificas.sort((a, b) => a.descripcion.localeCompare(b.descripcion));
};

export const getModalTitle = (selected) => {
  const esRecibo = selected?.endpoint?.includes('/recaudacion/recibos/');
  const folio = selected?.data_salida?.recibos?.[0]?.folio;

  return esRecibo && folio
    ? `Recibo ${folio}`
    : 'Detalle de historial';
};
export const extractDescripcionFromRecord = (row) => {
  const { data_salida, data_anterior, data_nueva } = row;

  return data_salida?.descripcion
      ?? data_anterior?.descripcion
      ?? data_nueva?.descripcion
      ?? '-';
};
export const extractClaveFromRecord = (row) => {
  const {
    endpoint,
    data_salida,
    data_anterior,
    data_nueva,
    orden_de_pago,
  } = row;

  const patterns = {
    esRecibo: endpoint?.includes('/recaudacion/recibos/'),
    esPredio: endpoint?.includes('/catastro/predios/'),
    esCaja: endpoint?.includes('/recaudacion/consulta-caja/padron/'),
    esFactura: endpoint?.match(/\/recaudacion\/recibos\/(\d+)\/facturacion\/?/),
    esOrdenPago: endpoint?.includes('/recaudacion/referencias-pago-netpay/'),
    esInfraccionid: endpoint?.match(/\/recaudacion\/infracciones\/(\d+)\/?/),
    esConceptoInf: endpoint?.includes('/recaudacion/conceptos-de-infracciones/'),
    esInfraccion: endpoint?.includes('/recaudacion/infracciones/'),
    esExpModMerc: endpoint?.includes('/empresas/expediente-modulos-de-mercados/'),
    esGirosMod: endpoint?.includes('/empresas/giros-de-modulos/'),
    esAnuncio: endpoint?.includes('/empresas/expedientes-de-anuncios/'),
    esEstmto: endpoint?.includes('/empresas/estacionamientos/'),
    esPanteonLoteid: endpoint?.match(/\/recaudacion\/lotes-de-pantones\/(\d+)\/?/),
    esPanteonLote: endpoint?.includes('/recaudacion/lotes-de-pantones/'),
    esCargo: endpoint?.match(/\/recaudacion\/cargos\/(\d+)\/?/),
  };

  if (patterns.esRecibo && orden_de_pago?.folio) {
    return orden_de_pago.folio;
  }

  if (patterns.esPredio && data_salida?.clave) {
    return data_salida.clave;
  }

  if (patterns.esCaja && data_salida?.[0]?.clave) {
    return data_salida[0].clave;
  }

  if (patterns.esFactura) {
    return data_anterior?.folio_de_facturacion
           ?? data_nueva?.folio_de_facturacion
           ?? data_salida?.recibos?.[0]?.folio
           ?? '';
  }

  if (patterns.esOrdenPago && orden_de_pago?.folio) {
    return orden_de_pago.folio;
  }

  if (patterns.esInfraccionid && data_salida?.clave) {
    return data_salida.clave;
  }

  if (patterns.esConceptoInf && data_nueva?.clave_de_tipo_de_concepto) {
    return data_nueva.clave_de_tipo_de_concepto;
  }

  if (patterns.esInfraccion && data_salida?.clave) {
    return data_salida.clave;
  }

  if (patterns.esExpModMerc && data_salida) {
    return data_salida.clave ?? (data_salida.id ? String(data_salida.id) : '');
  }

  if (patterns.esGirosMod) {
    const claveExpedienteAnterior = data_anterior?.expediente_modulo?.match(/Clave:\s*([0-9A-Z-]+)/i)?.[1];
    const expIdGiro = data_salida?.expediente_modulo ?? data_nueva?.expediente_modulo;
    const idGiroEndpoint = endpoint?.match(/\/empresas\/giros-de-modulos\/(\d+)\/?/)?.[1];

    return claveExpedienteAnterior
    ?? data_salida?.clave
    ?? (expIdGiro ? String(expIdGiro) : '')
    ?? (idGiroEndpoint ? String(idGiroEndpoint) : '');
  }

  if (patterns.esAnuncio && data_salida?.clave) {
    return data_salida.clave;
  }

  if (patterns.esEstmto && data_salida?.clave) {
    return data_salida.clave;
  }

  if ((patterns.esPanteonLoteid || patterns.esPanteonLote) && data_salida?.folio) {
    return data_salida.folio;
  }
  if (patterns.esCargo) {
    return data_salida?.tramite?.folio
    ?? data_anterior?.id
    ?? '';
  }

  return row.clave ?? data_salida?.clave ?? data_anterior?.clave ?? data_salida?.id ?? '-';
};

export const formatFecha = (fecha) => (fecha ? Moment(fecha).format('DD/MM/YYYY HH:mm:ss') : '');

// Extrae { periodo, descripcion } desde infoCargoAplicado (APLICAR_DESCUENTO)
// o desde data_anterior (CARGO_PRESCRIPTO / CANCELAR_CARGO)
const extractCargoPeriodoInfo = (r) => {
  if (r.data_nueva?.infoCargoAplicado) return r.data_nueva.infoCargoAplicado;
  const periodo = Number(r.data_anterior?.periodo_fiscal);
  const descripcion = r.data_anterior?.descripcion || r.data_salida?.descripcion;
  if (periodo && descripcion) return { periodo, descripcion };
  return null;
};

export const computeRangoInfo = (records) => {
  const withInfo = records
    .map((r) => ({ info: extractCargoPeriodoInfo(r) }))
    .filter((x) => x.info !== null);
  if (!withInfo.length) return null;
  const sorted = [...withInfo].sort((a, b) => {
    if (a.info.periodo !== b.info.periodo) return a.info.periodo - b.info.periodo;
    const bA = parseInt((a.info.descripcion || '').match(/BIMESTRE\s+(\d+)/i)?.[1] || '0', 10);
    const bB = parseInt((b.info.descripcion || '').match(/BIMESTRE\s+(\d+)/i)?.[1] || '0', 10);
    return bA - bB;
  });
  const first = sorted[0].info;
  const last = sorted[sorted.length - 1].info;
  const inicio = `${first.periodo} · ${first.descripcion}`;
  const fin = `${last.periodo} · ${last.descripcion}`;
  return inicio === fin ? inicio : `${inicio} — ${fin}`;
};
